module.exports = __webpack_public_path__ + "static/media/sortie_usine.31e5887.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/sortie_usine.mp4
// module id = 42
// module chunks = 0